import { useState } from "react";
import OperationalLayout from "../../../components/OperationalLayout";
import BreaksNotedCard from "../../../components/BreaksNotedCard";
import { rankinPgcDataMock, topTop200PgcDataMock } from "../../../mockData/mockData";
import TopPGCCard from "../../../components/TopPGCCard";
import TopPFTCard from "../../../components/TopPFTCard";
import { useStores } from "../../../context/storesContext";
import useSWR from "swr";
import { fetcherWithStoreKey } from "../../../utils/fetcher";
import {
  ListDetention,
  Detention as DetentionType,
  Rupture,
  VabType,
  DetentionTypology,
  ListDetentionTypology,
} from "../../../types/operational";
import VABCard from "../../../components/VABCard";
import { useOptionDetention, useOptionDetentionPGC, useOptionVAB } from "../../../utils/options";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useKpiVisibility } from "../../../kpis/useKpiVisibility";
import TypoCard from "../../../components/TypoCard";
import { Choice } from "../../../types/commercial";
import { SingleValue } from "react-select";
import { eventTrack } from "../../../utils/gtag";
import { useRange } from "../../../context/rangeContext";
import { Range } from "../../../utils/range";

function Detention() {
  const { selectedStore } = useStores();
  const [searchParams] = useSearchParams();
  const optionVAB = useOptionVAB();
  const detentionOptions = useOptionDetention();
  const {t} = useTranslation();
  const {isKpiExists, isModuleExists} = useKpiVisibility();
  const { getKpiRange, setKpiRange } = useRange();

  const vabRange = searchParams.get("shrinkage") ?? getKpiRange('shrinkage') ?? optionVAB?.[0].value;
  const detentionPGCRange = getKpiRange('detentionPGC') ?? detentionOptions?.[0].value;
  const detentionPFTRange = getKpiRange('detentionPFT') ?? detentionOptions?.[0].value;
  const detentionTop200PgcRange = getKpiRange('detentionTop200PGC') ?? detentionOptions?.[0].value;


  const [selectedPGCRange, setSelectedPGCRange] = useState(detentionPGCRange as string);
  const [selectedTop200PgcRange, setSelectedTop200PgcRange] = useState(detentionTop200PgcRange as string);
  const [selectedPFTRange, setSelectedPFTRange] = useState(detentionPFTRange as string);

  //CASSE MAGASIN
  const { data: stockoutsData, error: stockoutsError } = useSWR<Rupture>(
    () =>
      selectedStore?.storeKey
        ? [
            `/operational/stockouts?storeType=${selectedStore?.storeType?.toUpperCase()}`,
            
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeEan]) =>
      fetcherWithStoreKey(url,  storeEan as string)
  );
  //Detention Top3000 PGC
  const { data: detentionPgcData, error: detentionPgcError } =
    useSWR<ListDetention>(
      () =>
        selectedStore?.storeKey
          ? [
              `/operational/detention?range=${selectedPGCRange}&storeType=${selectedStore?.storeType?.toUpperCase()}&sector=PGC&flag=TOP3000`,
              
              selectedStore?.storeKey as string,
            ]
          : null,
      ([url, storeEan]) =>
        fetcherWithStoreKey(url,  storeEan as string)
    );

  //Detention Top200 PGC
  const { data: detentionTop200PgcData, error:  detentionTop200PgcError } =
    useSWR<ListDetention>(
      () =>
        selectedStore?.storeKey
          ? [
              `/operational/detention?range=${selectedTop200PgcRange}&storeType=${selectedStore?.storeType?.toUpperCase()}&sector=PGC&flag=TOP200`,
              selectedStore?.storeKey as string,
            ]
          : null,
      ([url, storeEan]) =>
        fetcherWithStoreKey(url,  storeEan as string)
    );

  //Detention Typology
  const { data: detentionTypologyData, error: detentionTypologyError } =
    useSWR<ListDetentionTypology>(
      () =>
        selectedStore?.storeKey
          ? [
              `/operational/detentionTypology?storeType=${selectedStore?.storeType?.toUpperCase()}&typology=T1`,

              selectedStore?.storeKey as string,
            ]
          : null,
      ([url, storeEan]) =>
        fetcherWithStoreKey(url,  storeEan as string)
    );
  //Detention PFT
  const { data: detentionPftData, error: detentionPftError } =
    useSWR<ListDetention>(
      () =>
        selectedStore?.storeKey
          ? [
              `/operational/detention?range=${selectedPFTRange}&storeType=${selectedStore?.storeType?.toUpperCase()}&sector=PFT&flag=TOP25`,
              
              selectedStore?.storeKey as string,
            ]
          : null,
      ([url, storeEan]) =>
        fetcherWithStoreKey(url,  storeEan as string)
    );

  // VAB
  const { data: vabData, error: vabError } = useSWR<VabType>(
    () =>
      selectedStore?.storeKey
        ? [
            `/operational/vab?range=${vabRange}`,
            
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeEan]) =>
      fetcherWithStoreKey(url,  storeEan as string)
  );

  // Get the correct options based on daySelected
  const detentionOptionsPGC = useOptionDetentionPGC(detentionPgcData?.daySelected);
  const detentionOptionsTop200PGC = useOptionDetentionPGC(detentionTop200PgcData?.daySelected);

  if (!isModuleExists("Operationnel")) {
    return null;
  }
  
  const handlePGCRangeChange = (choice: SingleValue<Choice>) => {
      const value = choice?.value as string;
        if (value === selectedPGCRange) {
          return;
        }
        //tracking changed
        eventTrack({
          eventName: "interaction_metric",
          actionName: "filter applied",
          key1: "metric_name",
          value1: t('operationnel.detention_top_3000_pgc'),
          key2: "filter_name",
          value2: value,
        });
    setKpiRange('detentionPGC', value as Range);
    setSelectedPGCRange(value);
  };

    const handlePFTRangeChange = (choice: SingleValue<Choice>) => {
      const value = choice?.value as string;
        if (value === selectedPFTRange) {
          return;
        }
        //tracking changed
        eventTrack({
          eventName: "interaction_metric",
          actionName: "filter applied",
          key1: "metric_name",
          value1: t('operationnel.detention_top_25_pft'),
          key2: "filter_name",
          value2: value,
        });
    setKpiRange('detentionPFT', value as Range);
    setSelectedPFTRange(value);
  };

   const handleTop200PgcRangeChange = (choice: SingleValue<Choice>) => {
      const value = choice?.value as string;
        if (value === selectedTop200PgcRange) {
          return;
        }
        //tracking changed
        eventTrack({
          eventName: "interaction_metric",
          actionName: "filter applied",
          key1: "metric_name",
          value1: t('operationnel.detention_top_200_pgc'),
          key2: "filter_name",
          value2: value,
        });
    setKpiRange('detentionTop200PGC', value as Range);
    setSelectedTop200PgcRange(value);
  };

  return (
    <OperationalLayout title={t('operationnel.detention')}>
      {isKpiExists("Detention", "Top200Pgc") && (
         <TopPGCCard
          value={detentionTop200PgcData?.rate as number}
          range={detentionTop200PgcData?.daySelected as string}
          options={detentionOptionsTop200PGC}
          title={t('operationnel.detention_top_200_pgc')}
          selectedRange={selectedTop200PgcRange}
          handleRangeChange={handleTop200PgcRangeChange}
          ranking={topTop200PgcDataMock}
          listValue={detentionTop200PgcData?.listResults as DetentionType[]}
          isLoading={!detentionTop200PgcData}
          isUnavailable={!!detentionTop200PgcError || detentionTop200PgcData?.rate === null}
          openInformationModal={() => null}
          importedDateTime={detentionTop200PgcData?.importedDateTime}
        />
      )}
      { isKpiExists("Detention", "Typology1") && selectedStore?.affiliation === "FRANCHISE" && (
        <TypoCard
          value={detentionTypologyData?.rate as number}
          listValue={detentionTypologyData?.listResults as DetentionTypology[]}
          isLoading={!detentionTypologyData}
          isUnavailable={!!detentionTypologyError || detentionTypologyData?.rate === null}
          openInformationModal={() => null}
          importedDateTime={detentionTypologyData?.importedDateTime}
        />
      )}

      {isKpiExists("Detention", "TopPGC") && (
        <TopPGCCard
          value={detentionPgcData?.rate as number}
          range={detentionPgcData?.daySelected as string}
          options={detentionOptionsPGC}
          title={t('operationnel.detention_top_3000_pgc')}
          selectedRange={selectedPGCRange}
          handleRangeChange={handlePGCRangeChange}
          ranking={rankinPgcDataMock}
          listValue={detentionPgcData?.listResults as DetentionType[]}
          isLoading={!detentionPgcData}
          isUnavailable={!!detentionPgcError || detentionPgcData?.rate === null}
          openInformationModal={() => null}
          importedDateTime={detentionPgcData?.importedDateTime}
        />
      )}
      {isKpiExists("Detention", "VAB") && (
        <VABCard
          title={`${t('operationnel.alertes_top_3000_3jrs')} ${vabData?.daySelected || ''}`}
          controlData={vabData as VabType}
          options={optionVAB}
          isLoading={!vabData}
          isUnavailable={!!vabError || vabData?.daySelected === null}
          openInformationModal={() => null}
        />
      )}
      {isKpiExists("Detention", "TopPFT") && (
        <TopPFTCard
          value={detentionPftData?.rate as number}
          listValue={detentionPftData?.listResults as DetentionType[]}
          selectedRange={selectedPFTRange}
          handleRangeChange={handlePFTRangeChange}
          options={detentionOptions}
          isLoading={!detentionPftData}
          isUnavailable={!!detentionPftError || detentionPftData?.rate === null}
          openInformationModal={() => null}
          importedDateTime={detentionPftData?.importedDateTime}
        />
      )}
      {isKpiExists("Detention", "BreaksNoted") && (
        <BreaksNotedCard
          title={t('operationnel.ruptures_releves_j_1_23h')}
          amont={stockoutsData?.upstreamRootCauseCount as number}
          aval={stockoutsData?.downstreamRootCauseCount as number}
          ruptureTotal={stockoutsData?.stockoutsCount as number}
          listValue={
            stockoutsData?.stockoutsDetailByDepartment as Rupture["stockoutsDetailByDepartment"]
          }
          importedDateTime={stockoutsData?.importedDateTime}
          isLoading={!stockoutsData}
          isUnavailable={!!stockoutsError || stockoutsData === null || stockoutsData?.upstreamRootCauseCount === null}
          openInformationModal={() => null}
        />
      )}
    </OperationalLayout>
  );
}

export default Detention;
